import { render, staticRenderFns } from "./ContractsTable.vue?vue&type=template&id=20215f5c&scoped=true"
import script from "./ContractsTable.ts?vue&type=script&lang=ts&external"
export * from "./ContractsTable.ts?vue&type=script&lang=ts&external"
import style0 from "./ContractsTable.vue?vue&type=style&index=0&id=20215f5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20215f5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20215f5c')) {
      api.createRecord('20215f5c', component.options)
    } else {
      api.reload('20215f5c', component.options)
    }
    module.hot.accept("./ContractsTable.vue?vue&type=template&id=20215f5c&scoped=true", function () {
      api.rerender('20215f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/History/components/ContractsTable/ContractsTable.vue"
export default component.exports